import { render, staticRenderFns } from "./ApproveMissingTransaction.vue?vue&type=template&id=1dcd8948&scoped=true"
import script from "./ApproveMissingTransaction.vue?vue&type=script&lang=js"
export * from "./ApproveMissingTransaction.vue?vue&type=script&lang=js"
import style0 from "./ApproveMissingTransaction.vue?vue&type=style&index=0&id=1dcd8948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd8948",
  null
  
)

export default component.exports